export const HANDLES = {
  PROTECTED: 'PROTECTED',
  UNPROTECTED: 'UNPROTECTED',
} as const;
